import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'formiojs';
import _cloneDeep from 'lodash/cloneDeep';
import { Subscription, finalize, forkJoin } from 'rxjs';
import * as DeleteConfirmationDialog from 'dp-formio';
import {
	ErrorToast,
	FormioCustomComponent,
	FormioLoader,
	ResourceNameService,
	ViewerComponent,
} from 'dp-formio';
import { AddEditEditgridContent } from './add-edit-editgrid-content/add-edit-editgrid-content.component';

import { ResizedEvent } from 'angular-resize-event';
import Formio from 'formiojs/Formio';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Table } from 'primeng/table';
import { ResourceGridEventModel } from 'src/formio-custom-components/src/lib/shared/model';

const DEFAULT_TABLET_WIDTH = 801;
@Component({
	selector: 'app-editgrid-resource-wrapper',
	templateUrl: './editgrid-resource-wrapper.component.html',
	// styleUrls: ['./editgrid-resource-wrapper.component.scss']
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class EditgridResourceWrapperComponent
	implements FormioCustomComponent<any>, OnInit, OnDestroy, OnChanges
{
	@ViewChild('formFilter')
	formFilterComponent: DeleteConfirmationDialog.FormioComponent;
	@ViewChild(Table) dataTable: Table;

	dir: 'rtl' | 'ltr';
	@Input() required: boolean;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Input() disabled: boolean;
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;
	totalRecords = 0;
	limit = 0;
	filterFormData = { data: {} };
	formQuery = '';

	isEndpoint = false;
	evaluatedUrl = ``;

	private subs: Subscription[] = [];
	set sub(s: Subscription) {
		this.subs.push(s);
	}

	windowProperties = {
		fullscreen: false,
		open: false,
	};

	name: string;
	actions: string[] = ['view', 'add', 'edit', 'delete'];
	showColumns: any[] = [];
	currentItem: any = null;
	private _editGridItems = [];

	get editGridItems(): any[] {
		return this._editGridItems;
	}

	set editGridItems(value: any[]) {
		this._editGridItems = value;
		if (this.customOptions?.enableSelected) {
			this.getSelectedItems();
		}
	}
	filteredItems = [];

	formFilterKey = '';
	filterIsOpen = false;
	filterCols = [];

	modifyInDialog: boolean;
	isDesktopDevice = true;
	enableAdaptiveScreen = false;

	externalActions: any = [];
	deletedItemsId = [];
	[x: string]: any;

	selectedItems: any[] = [];
	enableSelected: boolean;

	constructor(
		private translateService: TranslateService,
		private resourceNameService: ResourceNameService,
		private formioLoader: FormioLoader,
		private matDialog: MatDialog,
		private el: ElementRef,
		private toastrService: ToastrService
	) {
		this.changeDirection(this.translateService.currentLang);
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}
	ngOnInit() {
		this.sub = this.translateService.onLangChange.subscribe((lang) => {
			if (this.editGridItems?.length) {
				this.editGridItems = this.editGridItems.map((q) =>
					this.checkEvaluated(q)
				);
				this.notifyValue();
			}
		});
	}
	ngOnChanges(changes: SimpleChanges) {
		if (this.customOptions) {
			if (this.customOptions.viewType == 'horizontal')
				this.isDesktopDevice = false;
			else if (this.customOptions.viewType == 'adaptiveScreen') {
				this.enableAdaptiveScreen = true;
			} else this.isDesktopDevice = true;

			this.isEndpoint =
				!this.customOptions.resource && !!this.customOptions.url;
			if (this.isEndpoint) {
				this.evaluatedUrl = Utils.interpolate(this.customOptions.url, {
					config: this.formioComponent.root.form.config,
					data: this.data,
					translate: this.translateService.instant,
				});
			}

			if (this.customOptions.name) this.name = this.customOptions.name;
			if (this.customOptions.modifyInDialog)
				this.modifyInDialog = this.customOptions.modifyInDialog;
			if (this.customOptions.actions && this.customOptions.actions.length)
				this.actions = this.customOptions.actions;
			if (this.customOptions.formFilterKey)
				this.formFilterKey = this.customOptions.formFilterKey;
			if (
				this.customOptions.showColumns &&
				this.customOptions.showColumns.length
			) {
				this.showColumns = this.customOptions.showColumns;
				this.filterCols = this.showColumns
					.filter((q) => q.searchable)
					.map((q) => {
						return { ...q, value: '' };
					});
			}

			this.getExternalActions();

			this.getData();

			this.enableSelected = !!this.customOptions.enableSelected;
		}
	}

	private getSelectedItems() {
		const ids = Utils.evaluate(this.customOptions?.selectedIds, {
			data: this.data,
		}).split(',');
		if (ids?.length && this.editGridItems.length) {
			this.editGridItems.forEach((item) => {
				if (ids.includes(item._id.toString())) {
					const itemIndex = this.selectedItems.findIndex(
						(i) => i._id == item._id
					);
					if (itemIndex === -1) {
						this.selectedItems.push(item);
					}
				}
			});
		}
	}

	isChecked(id) {
		return this.selectedItems.findIndex((i) => i._id == id) > -1 ? true : false;
	}

	onCheckboxChange(item: any, event: any): void {
		const isChecked = event.target.checked;
		const itemIndex = this.selectedItems.findIndex((i) => i._id === item._id);

		if (isChecked) {
			if (itemIndex === -1) {
				this.selectedItems.push(item);
			}
		} else {
			if (itemIndex !== -1) {
				this.selectedItems.splice(itemIndex, 1);
			}
		}
	}

	onResized(event: ResizedEvent) {
		if (this.enableAdaptiveScreen) {
			this.isDesktopDevice =
				event.newWidth >
				(this.customOptions.defaultFlipWidth || DEFAULT_TABLET_WIDTH);
		}
	}

	getExternalActions() {
		if (this.customOptions.externalActions) {
			this.externalActions = this.customOptions.externalActions;
		}
	}

	async doAction(action, item, event: Event) {
		event?.target.dispatchEvent(
			new CustomEvent<ResourceGridEventModel>('resource-grid', {
				bubbles: true,
				detail: {
					data: this.data,
					rowSubmission: item,
					mode: 'custom',
					gridItems: this.editGridItems,
					formComponent: this.formioComponent,
				},
			})
		);

		try {
			let method = '';
			let body = {};
			let url = ``;

			action.body
				? (body = Utils.evaluate(action.body, {
						submission: this.data,
						row: item.data,
				  }))
				: (body = '');

			if (action.url) {
				action.method ? (method = action.method) : (method = 'GET');
				url += Utils.interpolate(action.url, {
					submission: this.data,
					config: this.formioComponent._currentForm._form.config,
					row: item.data,
				});
				await Formio.makeRequest(null, 'button', url, method, body, {
					ignoreCache: action.ignoreCache,
				});
				action.reload ? this.getData() : '';
			}
			if (action.script) {
				Utils.checkTrigger(
					this.formioComponent.component,
					{
						type: 'javascript',
						javascript: action.script,
					},
					item.data,
					this.formioComponent.data,
					this.formioComponent.root ? this.formioComponent.root._form : {},
					this.formioComponent
				);
				action.reload && !action.url ? this.getData() : '';
			}
			return true;
		} catch (error) {
			if (action.onFailure == 'ERROR') {
				if (action.errorMessage) {
					this.showError(action.onFailure, action.errorMessage);
				}
				return false;
			} else if (action && action.onFailure == 'CONTINUE') {
				return true;
			}
		}
	}

	private showError(title: string, message: string) {
		this.toastrService.show(message, title, {
			toastClass: 'notification-toast',
			closeButton: true,
			enableHtml: true,
			toastComponent: ErrorToast,
		});
	}

	openContent(
		event: Event,
		rowSubmission: any = null,
		isView: boolean = false
	) {
		event?.target.dispatchEvent(
			new CustomEvent<ResourceGridEventModel>('resource-grid', {
				bubbles: true,
				detail: {
					data: this.data,
					rowSubmission: rowSubmission,
					mode: rowSubmission ? (isView ? 'view' : 'edit') : 'add',
					gridItems: this.editGridItems,
					formComponent: this.formioComponent,
				},
			})
		);
		if (this.customOptions.dispatchEventOnly) {
			return;
		}
		if (this.modifyInDialog) {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.id = Utils.guid();
			dialogConfig.panelClass = 'custom-modal-component';
			dialogConfig.direction = this.dir;
			if (this.customOptions?.maxWidth) {
				dialogConfig.maxWidth = this.customOptions?.maxWidth;
			}
			dialogConfig.data = {
				isAdd: !rowSubmission,
				isView: isView,
				isEndpoint: this.isEndpoint,
				evaluatedUrl: this.evaluatedUrl,
				displayFormKey: this.customOptions.displayFormKey,
				resource: this.customOptions.resource,
				extra: this.customOptions.extra,
				data: this.data,
				dir: this.dir,
				rowSubmission: rowSubmission,
				editGridItems: this.editGridItems,
				closeActive: (data) => this.closeActive(data),
			};
			this.matDialog.closeAll();
			const modalDialog = this.matDialog.open(
				AddEditEditgridContent,
				dialogConfig
			);
			modalDialog.afterClosed().subscribe((data) => {
				this.closeActive(data);
				this.formioComponent?.root?.events?.emit('formio.registerComponent');
			});
		} else
			this.currentItem = {
				isAdd: !rowSubmission,
				isView: isView,
				isEndpoint: this.isEndpoint,
				evaluatedUrl: this.evaluatedUrl,
				displayFormKey: this.customOptions.displayFormKey,
				resource: this.customOptions.resource,
				extra: this.customOptions.extra,
				data: this.data,
				rowSubmission: rowSubmission,
			};
	}

	closeActive(event) {
		if (event) {
			if (event.isAdd) {
				//add item
				this.checkEvaluated(event.rowSubmission);
				this.editGridItems.push(event.rowSubmission);

				if (
					this.customOptions.saveResultObjectsOn &&
					this.data[this.customOptions.saveResultObjectsOn]
				) {
					this.data[this.customOptions.saveResultObjectsOn] =
						this.editGridItems;
				}

				this.notifyValue();
			} else if (!event.isView) {
				//edit item
				const index = this.editGridItems.findIndex(
					(q) => q._id == event.rowSubmission._id
				);
				this.checkEvaluated(event.rowSubmission);
				this.editGridItems[index] = event.rowSubmission;

				if (
					this.customOptions.saveResultObjectsOn &&
					this.data[this.customOptions.saveResultObjectsOn]
				) {
					const index = this.data[
						this.customOptions.saveResultObjectsOn
					].findIndex((q) => q._id == event.rowSubmission._id);
					if (index >= 0)
						this.data[this.customOptions.saveResultObjectsOn][index] =
							event.rowSubmission;
				}

				this.notifyValue();
			}

			this._dispatchEvent('rowAdded', {
				row: { _id: event.rowSubmission._id, data: event.rowSubmission.data },
			});
		}

		this.currentItem = null;
	}

	deleteContent(rowSubmission) {
		DeleteConfirmationDialog.build(
			this.formioComponent,
			() => {
				if (this.customOptions.enableExternalDelete) {
					this.editGridItems = this.editGridItems.filter(
						(q) => q._id != rowSubmission._id
					);
					this.deletedItemsId.push(rowSubmission._id);
					this.data.deletedItemsId = this.deletedItemsId;
					this.currentItem = null;
					this.notifyValue(true);
					this._dispatchEvent('rowDeleted', {
						row: { _id: rowSubmission._id, data: rowSubmission.data },
					});
				} else {
					const resource =
						this.customOptions.resource?.writeSubmissionOn ||
						this.customOptions.resource;

					const method = this.isEndpoint
						? this.resourceNameService.deleteByUrl(
								this.evaluatedUrl,
								rowSubmission._id
						  )
						: this.resourceNameService.deleteResourceData(
								resource,
								rowSubmission._id
						  );

					this.sub = method.subscribe(() => {
						this.editGridItems = this.editGridItems.filter(
							(q) => q._id != rowSubmission._id
						);
						this.currentItem = null;
						this.notifyValue(true);
						this._dispatchEvent('rowDeleted', {
							row: { _id: rowSubmission._id, data: rowSubmission.data },
						});
					});
				}
			},
			null,
			'Are you sure to delete this item'
		);
	}

	notifyValue(makeCalls: boolean = false) {
		this.filterData(makeCalls);
		this.saveResultObjectsOn();
		this.afterChangeValue();
		if (this.required && !this.editGridItems.length) {
			this.value = null;
			this.valueChange.emit(this.value);
			return;
		}

		if (!this.customOptions.withoutUpdate) {
			if (this.enableSelected) {
				this.value = {
					items: this.selectedItems,
				};
			} else {
				this.value = { list: this.editGridItems.map((q) => q._id) };
			}
			this.valueChange.emit(this.value);
		}
	}

	applyFilter() {
		this.filterIsOpen = false;
		this.filterData(true);
	}
	reset() {
		this.filterIsOpen = false;
		this.filterCols.forEach((q) => (q.value = ''));
		this.filterData(true);
	}

	onFiterCustomEvent(event) {
		this.filterIsOpen = !this.filterIsOpen;
		if (this.customOptions?.enablePagination) {
			const filters = {};
			const dateKeys = Utils.searchComponents(
				this.formFilterComponent.formio.components,
				{
					type: 'datetime',
				}
			)?.map((q) => q.component.key);

			Utils.searchComponents(this.formFilterComponent.formio.components, {
				'component.input': true,
			})
				.filter((comp) => comp.component.type != 'button')
				.forEach((comp) => {
					const key = comp.component.key;
					if (event.data[key]) {
						const filterKey = comp.component.properties?.mappedKey
							? Utils.evaluate(comp.component.properties?.mappedKey, {
									key: key,
									pref: comp.component.properties?.prefix || '',
									operator: comp.component.properties?.operator || '',
							  })
							: null;

						if (dateKeys.includes(key)) {
							const date = new Date(event.data[key].toString());
							date.setDate(date.getDate() + 1);

							if (this.isEndpoint) {
								if (comp.component.properties?.startOfDay) {
									date.setUTCHours(0, 0, 0, 0);
								} else if (comp.component.properties?.endOfDay) {
									date.setUTCHours(23, 59, 59, 999);
								}
							} else {
								if (key.endsWith('gte')) date.setUTCHours(0, 0, 0, 0);
								else if (key.endsWith('lte')) date.setUTCHours(23, 59, 59, 999);
							}

							filters[key] = {
								operator: comp.component.properties?.operator || '',
								value: new Date(date).toISOString(),
								mappedKey: filterKey,
							};
						} else {
							filters[key] = {
								operator: comp.component.properties?.operator || '',
								value: event.data[key],
								mappedKey: filterKey,
							};
						}
					}
				});
			this.formQuery = Object.keys(filters)
				.map((key) => {
					const compKey = filters[key].mappedKey
						? filters[key].mappedKey
						: `data.${key}${filters[key].operator}`;
					return `${compKey}=${filters[key].value}`;
				})
				.join('&');
			if (this.dataTable) {
				this.dataTable.reset();
			} else {
				this.loadPage();
			}

			if (this.customOptions?.applyFilters) {
				this.runScript(this.customOptions.applyFilters, { filters });
			}
		} else {
			let data = _cloneDeep(this.editGridItems);
			this.showColumns.forEach((item) => {
				if (event.data[item.key]) {
					data = data.filter((q) =>
						q.data[item.key].includes(event.data[item.key])
					);
				}
			});
			this.filteredItems = data;
			this.filterIsOpen = !this.filterIsOpen;
		}
	}

	openFile(file: any) {
		this.matDialog.open(ViewerComponent, {
			position: {
				top: '0',
				right: '0',
			},
			data: {
				dir: this.translateService.currentLang == 'ar' ? 'rtl' : 'ltr',
				data: {
					...file,
				},
				formId: this.formioComponent?.root?.form?._id,
				appUrl: `${this.formioComponent.root.formio.path
					.split('/')
					.slice(0, -1)
					.join('/')}/`,
			},
			height: '100vh',
			width: '100vw',
			panelClass: 'full-screen-modal',
		});
	}

	private filterData(makeCalls: boolean = false) {
		if (makeCalls && this.customOptions?.enablePagination) {
			const filters = [];
			this.filterCols
				.filter((col) => !!col.value)
				.forEach((col) => {
					filters.push(`data.${col.key}__regex=${col.value}`);
				});
			this.formQuery = filters.join('&');
			this.dataTable.reset();
		}

		let data = _cloneDeep(this.editGridItems);
		const filteredCols = this.filterCols.filter((q) => q.value);
		filteredCols.forEach((item) => {
			data = data.filter((q) =>
				q.data[`${item.key}Evaluated`].includes(item.value)
			);
		});
		this.filteredItems = data;
	}

	private getData() {
		if (this.customOptions?.enablePagination) {
			this.loadPage();
		} else {
			if (
				this.customOptions.saveResultObjectsOn &&
				this.data[this.customOptions.saveResultObjectsOn] &&
				this.data[this.customOptions.saveResultObjectsOn].length
			) {
				this.editGridItems = this.data[
					this.customOptions.saveResultObjectsOn
				].map((q) => this.checkEvaluated(q));
				this.notifyValue();
				return;
			}

			let query = ``;
			let sources = [];
			let bindRecordsQuery = ``;
			const bindRecordsResource = this.customOptions.resource;
			const resource =
				this.customOptions.resource?.writeSubmissionOn ||
				this.customOptions.resource;

			if (this.value?.list?.length && !this.customOptions.withoutUpdate) {
				if(this.data.currentRoute && this.data.currentRoute.includes('/reviewFile') ){
					query = `data.requestTimestamp=${this.data?.requestTimestamp}&sort=${
						this.customOptions?.sort ? this.customOptions?.sort : 'created'
					}&limit=10000&`;
				}else{
					query = `_id__in=${this.value?.list?.join()}&sort=${
						this.customOptions?.sort ? this.customOptions?.sort : 'created'
					}&limit=10000`;
				}
			}
			if (this.customOptions.query) {
				query += Utils.interpolate(this.customOptions.query, {
					data: this.data,
				});
			}
			if (!!query) {
				if (this.isEndpoint)
					sources.push(this.resourceNameService.load(this.evaluatedUrl, query));
				else
					sources.push(
						this.resourceNameService.loadCustomByFilterdKey(resource, query)
					);
				this.formioLoader.loading = true;
			}

			if (this.customOptions.bindRecordsQuery) {
				bindRecordsQuery += Utils.interpolate(
					this.customOptions.bindRecordsQuery,
					{
						data: this.data,
					}
				);
				sources.push(
					this.resourceNameService.loadCustomByFilterdKey(
						bindRecordsResource,
						bindRecordsQuery
					)
				);
			}

			forkJoin(...sources)
				.pipe(finalize(() => (this.formioLoader.loading = false)))
				.subscribe((res: any) => {
					const evaluatedBindRecords =
						res[1]?.map((i) => this.checkEvaluated(i)) || [];
					const evaluatedBaseData = res[0].map((q) => this.checkEvaluated(q));

					this.editGridItems = _.uniqBy(
						[...evaluatedBaseData, ...evaluatedBindRecords],
						'_id'
					);
					this._dispatchEvent('edit-grid-loaded', {});
					this.notifyValue();
				});
		}
	}

	private checkEvaluated(item) {
		this.showColumns.forEach((col) => {
			if (col.cssClass) return;
			if (col.evaluated) {
				const value = Utils.evaluate(col.evaluated, {
					data: this.data,
					[col.key]: item.data[col.key],
					lang: this.translateService.currentLang,
					row: item,
				});
				item.data[`${col.key}Evaluated`] = value;
			} else {
				item.data[`${col.key}Evaluated`] = item.data[col.key];
			}

			if (col.translatable && item.data[`${col.key}Evaluated`]) {
				item.data[`${col.key}Evaluated`] = this.translateService.instant(
					`forms.common.${item.data[`${col.key}Evaluated`]}`
				);
			}
		});
		return item;
	}

	private saveResultObjectsOn() {
		if (this.customOptions && this.customOptions.saveResultObjectsOn) {
			if (this.formioComponent.root.wizard) {
				const pages = this.formioComponent.root.getFastPages({
					all: true,
					withoutFirstLoad: true,
				});
				const components = Utils.searchComponents(pages, {
					key: this.customOptions.saveResultObjectsOn,
				});
				components.forEach((c) => {
					c.setValue(this.editGridItems);
				});
			} else {
				const nestedForms = Utils.searchComponents(
					this.formioComponent.root.components,
					{
						type: 'form',
						'component.display': 'wizard',
					}
				);
				nestedForms.forEach((formComponent) => {
					formComponent.subFormReady.then((subForm) => {
						const pages = subForm.getFastPages({
							all: true,
							withoutFirstLoad: true,
						});
						const components = Utils.searchComponents(pages, {
							key: this.customOptions.saveResultObjectsOn,
						});
						components.forEach((c) => {
							c.setValue(this.editGridItems);
						});
					});
				});

				const components = Utils.searchComponents(
					this.formioComponent.root.components,
					{
						key: this.customOptions.saveResultObjectsOn,
					}
				);
				components.forEach((c) => {
					c.setValue(this.editGridItems);
				});
			}
		}
	}
	private afterChangeValue() {
		if (this.customOptions && this.customOptions.afterChange)
			this.customOptions.afterChange.forEach((item) => {
				if (item.script) {
					this.runScript(item.script, {
						items: this.editGridItems,
						data: this.data,
						instance: this.formioComponent,
					});
				} else if (this.formioComponent.root.wizard) {
					const pages = this.formioComponent.root.getFastPages({
						all: true,
						withoutFirstLoad: true,
					});
					const components = Utils.searchComponents(pages, { key: item.key });
					components.forEach((c) => {
						if (item.checkConditions) {
							c.checkConditions();
						} else {
							const value = Utils.evaluate(item.value, {
								items: this.editGridItems,
								data: this.data,
								instance: this.formioComponent,
							});
							c.setValue(value);
						}
					});
				} else {
					const nestedForms = Utils.searchComponents(
						this.formioComponent.root.components,
						{
							type: 'form',
							'component.display': 'wizard',
						}
					);
					nestedForms.forEach((formComponent) => {
						formComponent.subFormReady.then((subForm) => {
							const pages = subForm.getFastPages({
								all: true,
								withoutFirstLoad: true,
							});
							const components = Utils.searchComponents(pages, {
								key: item.key,
							});
							components.forEach((c) => {
								if (item.checkConditions) {
									c.checkConditions();
								} else {
									const value = Utils.evaluate(item.value, {
										items: this.editGridItems,
										data: this.data,
										instance: this.formioComponent,
									});
									c.setValue(value);
								}
							});
						});
					});

					const components = Utils.searchComponents(
						this.formioComponent.root.components,
						{
							key: item.key,
						}
					);
					components.forEach((c) => {
						if (item.checkConditions) {
							c.checkConditions();
						} else {
							const value = Utils.evaluate(item.value, {
								items: this.editGridItems,
								data: this.data,
								instance: this.formioComponent,
							});
							c.setValue(value);
						}
					});
				}
			});
	}

	loadPage(event = null) {
		this.limit = this.customOptions?.pageSize || 10;
		const skip = event?.first || 0;
		let query = this.isEndpoint
			? ''
			: `sort=created&limit=${this.limit}&skip=${skip}&`;
		if (this.customOptions.query)
			query += Utils.interpolate(this.customOptions.query, {
				data: this.data,
				limit: this.limit,
				skip: skip,
			});
		if (this.formQuery) query += `&${this.formQuery}`;

		this.formioLoader.loading = true;
		const resource =
			this.customOptions.resource?.writeSubmissionOn ||
			this.customOptions.resource;

		const method = this.isEndpoint
			? this.resourceNameService.loadByPage(this.evaluatedUrl, query)
			: this.resourceNameService.loadPage(resource, query);

		this.sub = method.subscribe(
			(result) => {
				this.totalRecords = result.totalRecords;
				this.editGridItems = result.data.map((q) => this.checkEvaluated(q));
				this.notifyValue();
				this.formioLoader.loading = false;
			},
			(error) => {
				this.formioLoader.loading = false;
			}
		);
	}

	private _dispatchEvent(eventName, details) {
		const data = {
			componentKey: this.formioComponent.component.key,
			gridItems: this.editGridItems?.map((rw) => ({
				_id: rw?._id,
				data: rw?.data,
			})),
			customOptions: this.customOptions,
			data: this.data,
			value: this.value,
			...details,
		};
		const event = new CustomEvent<any>(eventName, {
			bubbles: true,
			detail: data,
		} as any);
		this.el.nativeElement.dispatchEvent(event);
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang === 'ar' ? 'rtl' : 'ltr';
		});
	}
	private runScript(query: String, params) {
		Utils.evaluate(query, {
			utils: Utils,
			instance: this.formioComponent,
			submission: this.formioComponent?.root?.data,
			translate: this.translateService,
			data: this.data,
			value: this.value,
			component: this.formioComponent.component,
			...params,
		});
	}
	ngOnDestroy() {
		this.subs.forEach((s) => s.unsubscribe());
		this.subs = [];
	}

	get isEnableView() {
		return !!this.actions.find((q) => q == 'view');
	}
	get isEnableAdd() {
		return !this.viewOnly && !!this.actions.find((q) => q == 'add');
	}
	get isEnableEdit() {
		return !this.viewOnly && !!this.actions.find((q) => q == 'edit');
	}
	get isEnableDelete() {
		return !this.viewOnly && !!this.actions.find((q) => q == 'delete');
	}
}
